// extracted by mini-css-extract-plugin
export var fadeInOut = "_40-3";
export var icon = "_40-4";
export var savedIndicator = "_40-2";
export var savingIndicator = "_40-0";
export var spin = "_40-1";